import { render, staticRenderFns } from "./CounselingReport.vue?vue&type=template&id=f5a1c15a&scoped=true"
import script from "./CounselingReport.vue?vue&type=script&lang=js"
export * from "./CounselingReport.vue?vue&type=script&lang=js"
import style0 from "./CounselingReport.vue?vue&type=style&index=0&id=f5a1c15a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a1c15a",
  null
  
)

export default component.exports